import React, { FC } from 'react';
import { toInterfaceDayFormat, toInterfaceHour } from 'utils/date';

import {
  Container,
  Dot,
  Content,
  MainText,
  SecondaryText,
  Wrap,
  Avatar,
  Text,
  Date,
  ActionButton,
} from './styles';
import StatusSelect from './StatusSelect';
import useConnect from './connect';
import { Props } from './types';

const Row: FC<Props> = ({ order, ...props }) => {
  const {
    isLoading,
    goToOrder,
    handlePrintOrder,
    handleClickSelect,
    handleChangeSelect,
  } = useConnect(order.id);

  return (
    <Container onClick={goToOrder} $unseen={order.unseen} {...props}>
      <Content>
        <Dot />
        <div>
          <MainText>{order.customer.name.displayName}</MainText>
          <SecondaryText>{order.itemCount} items</SecondaryText>
        </div>
        <Wrap>
          <Avatar src={order.brand.image.src} alt={order.brand.image.alt} />
          <Text>{order.brand.name}</Text>
        </Wrap>
        <Wrap>
          <Avatar
            src={order.integration.image.src}
            alt={order.integration.image.alt}
          />
          <div>
            <Text>{order.integration.orderId}</Text>
            <SecondaryText>{order.type.caption}</SecondaryText>
          </div>
        </Wrap>
        <Wrap>
          <Date>{toInterfaceDayFormat(order.createdAt)}</Date>
        </Wrap>
        <Date>{toInterfaceHour(order.createdAt)}</Date>
        <StatusSelect
          isLoading={order.isUpdatingStatus}
          value={order.status}
          onChange={handleChangeSelect}
          onClick={handleClickSelect}
          disabled={isLoading}
        />
        <ActionButton variant="print" onClick={handlePrintOrder} />
      </Content>
    </Container>
  );
};

export default Row;
